import { useTranslation } from 'react-i18next'
import { StatusText } from '@/features/Application/elements'

const StatusComponent = ({ status, isLocked }) => {
  const { t } = useTranslation()
  const texts = {
    verified: t('l.application.view.liv_rent_verified.label', 'liv.rent Verified'),
    unverified: t('l.application.view.not_connected.label', 'Not connected'),
    provided: t('l.application.view.provided.label', 'Provided'),
    not_provided: t('l.application.view.not_provided.label', 'Not Provided')
  }

  const text = texts?.[status]

  const types = {
    verified: 'success',
    unverified: 'default',
    provided: 'provided',
    not_provided: 'not_provided'
  }

  const type = types?.[status]

  const tooltips = {
    removed: t(
      'l.application.status.removed.label',
      "This document has either been deleted by the renter, or the liv.rent team has removed it as it didn't meet our verification requirements."
    ),
    pending: t(
      'l.application.view.document_pending.label',
      'This document is pending verification by the liv.rent team. Please check back in 1-3 business days.'
    )
  }

  const tooltip = tooltips?.[status]

  return <StatusText title={text} type={type} tooltip={tooltip} isLocked={isLocked} />
}

export default StatusComponent
